import React from 'react';
import ForgotPasswordForm from '../../components/auth/ForgotPasswordForm/ForgotPasswordForm';

function ForgotPassword() {
  return (
    <div className="d-flex a-center j-center full-view-height mobile-a-stretch">
      <ForgotPasswordForm />
    </div>
  );
}

export default ForgotPassword;
